import React from "react";
import "./FilterTags.css";

const FilterTags = ({ categories, selected, onSelect, title }) => {
  return (
    <div className={`filters-wrapper ${title ? "" : "no-title"}`}>
      {title && <h2 className="filters-title">{title}</h2>}
      <div className="filters-buttons">
        {["Hepsi", ...categories].map((cat, index) => (
          <button
            key={index}
            className={selected === cat ? "active" : ""}
            onClick={() => onSelect(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterTags;
